import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button, Select } from 'components';
import { Field, Form, Formik } from 'formik';
import { downloadXlsx } from 'helpers/downloadXlsx';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providersService } from 'services';

import { formatDate } from '../../../../helpers/formateDate';

export const ControlSacMangementReport = () => {
  const operations = [
    { label: 'TODOS', value: 0 },
    { label: 'E-COMMERCE', value: 7 },
    { label: 'NÃO SERIALIZADO', value: 20 },
    { label: 'RFB CENTER CELL', value: 10 },
    { label: 'RFB FURBTECH SOR', value: 21 },
    { label: 'RFB SAMSUNG', value: 9 },
    { label: 'RFB TECH CENTER', value: 19 },
  ];
  const [loading, setIsLoading] = useState(false);
  const now = new Date();

  const handleExport = async (values) => {
    setIsLoading(true);
    toast.info('Aguarde relatório sendo gerado...');
    try {
      const { data } = await providersService.controlSacMangementReport({ values });
      const result = data.result;
      const date = await formatDate(now);

      if (data.status === 200) {
        toast.success(data.msg);
        await downloadXlsx(`Relatório_Controle_SAC_gestao${date}`, result);
        setIsLoading(false);
      } else {
        toast.error(data.msg);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error.message);
      setIsLoading(false);
    }
  };
  return (
    <>
      <PageTitle>Controle SAC-Gestão</PageTitle>

      <Formik
        initialValues={{
          operation: 0,
        }}
        onSubmit={handleExport}
      >
        {(props) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={2}>
                <Field
                  size='small'
                  variant='outlined'
                  component={Select}
                  name='operation'
                  label='Operação'
                  options={operations}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={2}>
                <Button type='submit' fullWidth loading={loading}>
                  Exportar Relatório
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};
